import { IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  videoButtons: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    zIndex: '999',
    top: theme.spacing(1),
    right: theme.spacing(1),
    color: 'white',
    '&$popoutMode': {
      display: 'none'
    }
  },
  popoutMode: {},
  buttonBackground: {
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    color: 'white',
    marginLeft: '10px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.2)'
    },
    '&:focus': {
      outline: 'white solid 2px'
    }
  },
  spinner: {
    position: 'absolute',
    zIndex: 1,
    width: 20,
    height: 20
  },
  iconButtonLabel: {
    position: 'relative'
  },
  buttonActive: {
    backgroundColor: 'rgba(3, 169, 244,.6)'
  },
  cast: {
    width: 24,
    height: 24,
    color: 'white',
    // use this to apply a contrastText if your theme
    // is unusual
    '--disconnected-color': 'white',
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    marginLeft: '10px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.2)'
    },
    '&:focus': {
      outline: 'white solid 2px'
    }
  },
  buttonBackgroundBackUp: {
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    color: 'white',
    marginLeft: '10px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.2)'
    },
    '&:focus': {
      outline: 'white solid 2px'
    },
    width: 24,
    height: 24,
    // use this to apply a contrastText if your theme
    // is unusual
    '--disconnected-color': 'white'
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/VideoButtons/ChromeCastButton/styles.js